export default "__VITE_ASSET__8eaaaa6e__"